<template>
	<div class="about">
			<div class="img">
				<img :src="banner"/>
			</div>
			<!--路径-->
			<div class="container">
				<div class="path">
					<el-breadcrumb separator-class="el-icon-arrow-right">
					  	<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
					  	<el-breadcrumb-item>{{sel}}</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				
				<!--内容-->
				<div class="content">
					<div class="title">
						<ul>
								<li @click="selItem(item)" 
								:class="sel3===item.name?'active':''" 
								v-for="(item,index) in navlist"
								:key="index" >
								{{item.title}}
								</li>
								
							</ul>
					</div>
					<router-view/>		
					
				</div>
				
			</div>
			
		
	</div>
</template>

<script>
	
	export default {
		name:'',
		components:{},
		data(){
			return{
				msg:'about',
				path:'',
				banner:'',
				navlist: [
							{
								title: '公司简介',
								name: 'profile',
								rou: '/About/'
							},
							{
								title: '公司文化',
								name: 'cultrue',
								rou: '/About/Culture'
							},
							{
								title: '荣誉资质',
								name: 'honor',
								rou: '/About/Honor'
							},
						
				],
				sel3:'profile',
				sel:''
			}
		},
		methods:{
			getItem(){
				var url = this.$route.path;
				var regstr = '/About/';
				var str = url.replace(regstr, '');
				if(str == ''){
					this.sel3 = 'profile';
					this.sel = '公司简介';
				}else if(str == 'Culture'){
					this.sel3 = 'cultrue';
					this.sel = '公司文化';
				}else if (str == 'Honor') {
					this.sel3 = 'honor';
					this.sel = '荣誉资质';
				}
			},
			selItem(item) {
				this.sel3 = item.name; 
				this.$router.push(item.rou);
			},
			getBanner(){
				this.axios({
					method: 'get',
					url: this.GLOBAL.getBannerApi+'2',
					data: {}
				})
				.then((res) => {
					this.banner = res.data.data.banner2;
				})
				.catch((err) => {
					console.log(err)
				})
			}
		},
		created(){

			this.getBanner();
			this.getItem();
		}
	}
</script>

<style lang="less" scoped="scoped">
.about{
	.img{
		width:100%;
		height:350px;
		img{
			width: 100%;
			height: 100%;
		}
	}
	.path{
		margin-top: 20px;
		margin-bottom: 20px;
		i{
			font-size: 20px;
		}
		span{
			color: #00A0FF;
		}
	}
	.content{
		margin-top: 50px;
		margin-bottom: 50px;
		.title{
			text-align: center;
			ul{
				li{
					display: inline-block;
					margin-left: 40px;
					width: 120px;
					height: 40px;	
					background: #eee;	
					text-align: center;
					line-height: 40px;	
				}
				.active{
					background: #00A0FF;
					color: #fff;
				}
			}
			P{
				margin-top: 50px;
				font-size: 26px;
				color: #00A0FF;
			}
			h3{
				margin-top: 10px;
				font-size: 26px;
				font-weight: 600;
				margin-bottom: 50px;
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/pages/About/About.vue